import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import { StockLocationActions, StockLocationStore, STATUS } from 'Stores/stockLocationStore'

export default class StockLocationList extends Component {
  constructor(props) {
    super(props)
    this.stores = [StockLocationStore]
    this.storeKeys = ['stockLocations', 'status']
  }

  componentDidMount() {
    StockLocationActions.getStockLocations()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching Stock Placements Failed', {
        autoClose: 7500,
        onClose: () => {
          StockLocationActions.clearToast()
        }
      })
      StockLocationActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Delete Stoc kPlacement Failed', {
        autoClose: 7500,
        onClose: () => {
          StockLocationActions.clearToast()
        }
      })
      StockLocationActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('Stock Placement Deleted', {
        autoClose: 7500,
        onClose: () => {
          StockLocationActions.clearToast()
        }
      })
      StockLocationActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <CollapsibleCard startOpen header={<strong>Lagerpladser</strong>}>
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'StockLocationID'
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup style={{ float: 'right' }}>
                    <Tooltip target={'edit' + e.StockLocationID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/stockLocations/' + e.StockLocationID} id={'edit' + e.StockLocationID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Tooltip target={'delete' + e.StockLocationID}>Slet</Tooltip>
                    <Button
                      id={'delete' + e.StockLocationID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Vil du slette denne lagerplads?')) {
                          StockLocationActions.deleteStockLocation(e.StockLocationID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            StockLocationID: 'ID',
            name: 'Navn'
          }}
          data={this.state.stockLocations}
        />
      </CollapsibleCard>
    )
  }
}
